import React, { Component, Fragment } from 'react'
import { Translate } from 'react-redux-i18n'
import GlobalLoadingIndicator from '../global-loading-indicator'
import {
  sendResaleVerification,
  confirmResaleVerification
} from '../../actions/tickets'

class TicketResaleVerification extends Component {
  state = {
    code: ''
  }

  handleSend = () => {
    const { dispatch, ticketCode } = this.props
    dispatch(sendResaleVerification(ticketCode))
  }

  handleConfirm = e => {
    e.preventDefault()
    const { dispatch, ticketCode } = this.props
    dispatch(confirmResaleVerification(ticketCode, this.state.code.trim()))
  }

  handleCodeChange = e => {
    const code = e.target.value.replace(/\D/g, '').slice(0, 6)
    this.setState({ code })
  }

  renderDestination() {
    const { verification, resaleVerification } = this.props
    const channel =
      resaleVerification.channel || (verification && verification.channel)
    const masked =
      resaleVerification.masked || (verification && verification.masked)

    if (!masked) {
      return null
    }

    return (
      <div className="ticket-resale-verification-destination">
        {channel === 'phone' ? (
          <Translate
            value="tickets.resale_verification_send_to_phone"
            masked={masked}
          />
        ) : (
          <Translate
            value="tickets.resale_verification_send_to_email"
            masked={masked}
          />
        )}
      </div>
    )
  }

  render() {
    const {
      resaleVerification,
      ticketInfo,
      verification
    } = this.props

    if (!verification || !verification.available || ticketInfo.verified) {
      return null
    }

    const {
      isSending,
      isConfirming,
      codeSent,
      validTo,
      error
    } = resaleVerification

    return (
      <div className="ticket-resale-verification">
        <div className="ticket-resale-verification-title">
          <Translate value="tickets.resale_verification_title" />
        </div>
        <div className="ticket-resale-verification-description">
          <Translate value="tickets.resale_verification_description" />
        </div>

        {!codeSent ? (
          <Fragment>
            {this.renderDestination()}
            <div className="break-sm" />
            <button
              type="button"
              className="button-wide"
              disabled={isSending}
              onClick={this.handleSend}
            >
              {isSending ? (
                <GlobalLoadingIndicator center secondary />
              ) : (
                <Translate value="tickets.resale_verification_send_code" />
              )}
            </button>
          </Fragment>
        ) : (
          <form onSubmit={this.handleConfirm}>
            {this.renderDestination()}
            {validTo && (
              <div className="ticket-resale-verification-valid-to">
                <Translate
                  value="tickets.resale_verification_valid_to"
                  validTo={validTo}
                />
              </div>
            )}
            <div className="break-sm" />
            <label htmlFor="resaleVerificationCode">
              <Translate value="tickets.resale_verification_code" />
            </label>
            <input
              id="resaleVerificationCode"
              type="text"
              inputMode="numeric"
              autoComplete="one-time-code"
              className="ticket-code-input ticket-resale-verification-code"
              value={this.state.code}
              onChange={this.handleCodeChange}
              maxLength={6}
              required
            />
            {error && <div className="error-message">{error}</div>}
            <div className="break-sm" />
            <button
              type="submit"
              className="button-wide"
              disabled={isConfirming || this.state.code.length !== 6}
            >
              {isConfirming ? (
                <GlobalLoadingIndicator center secondary />
              ) : (
                <Translate value="tickets.resale_verification_confirm" />
              )}
            </button>
            <div className="break-sm" />
            <button
              type="button"
              className="secondary-button button-wide"
              disabled={isSending}
              onClick={this.handleSend}
            >
              <Translate value="tickets.resale_verification_resend" />
            </button>
          </form>
        )}
      </div>
    )
  }
}

export default TicketResaleVerification
